module.exports = __webpack_public_path__ + "img/MS.dd5f90f3.png";